import React, { Component } from 'react'
import {
  BarChart,
  XAxis,
  YAxis,
  Bar,
  ResponsiveContainer,
  Cell,
} from 'recharts'
import naturalCompare from 'natural-compare'
import {
  Grid,
  Form,
  Chart,
  Segment,
  Scrollable,
} from 'components/UI'

import Color from 'helpers/Color'
import BarLabel from './BarLabel'

function handleItemClick (index, callback, data) {
  if (callback) callback(data[index].id)
}

class TemperatureBar extends Component {
  state = {
    sort: 'value',
  }

  handleSortChange = (event) => {
    this.setState({ sort: event.target.value })
  }

  chartWrapper = ({ children }) => {
    if (this.props.scrollable) {
      return (
        <Scrollable height={280}>
          {children}
        </Scrollable>
      )
    } else {
      return (
        <div>
          {children}
        </div>
      )
    }
  }

  render () {
    const {
      data,
      dataKey = 'temp',
      barHeight = 30,
      legendWidth = 50,
      onItemClick,
      color,
      title,
    } = this.props

    const { sort } = this.state

    // We want ascending for names (A to Z), but descending for temperatures (high to low).
    const order = sort === 'name' ? 1 : -1

    if (data.length === 0) return <div />
  
    const chartData = data.map(item => {
      return {
        id: item.id,
        name: item.name,
        value: parseInt(item[dataKey], 10) || 0,
      }
    }).sort((a, b) => order * naturalCompare(a[sort], b[sort]))
  
    const cells = chartData.map(item => {
      const itemColor = item.value ? color || Color.fromTemperature(item.value) : Color.gray
      return (
        <Cell
          key={item.id}
          fill={itemColor}
        />
      )
    })
  
    const chartHeight = data.length * barHeight + 10
  
    return [
      <Grid.Row key='header'>
        <Grid.Col width={2}>
          <h2>{title}</h2>
          <Chart.TemperatureLegend small />
        </Grid.Col>
        <Grid.Col>
          <h3>Sort by:</h3>
          <Form.Select
            items={[
              { value: 'name', name: 'Name' },
              { value: 'value', name: 'Temperature' },
            ]}
            selected={this.state.sort}
            onChange={this.handleSortChange}
          />
        </Grid.Col>
      </Grid.Row>,
      <Segment.Child key='body'>
        <this.chartWrapper>
          <ResponsiveContainer
            width='100%'
            height={chartHeight}
          >
            <BarChart
              layout='vertical'
              data={chartData}
            >
              <XAxis
                type='number'
                hide
              />
              <YAxis
                type='category'
                dataKey='name'
                width={legendWidth}
                tickLine={false}
                axisLine={false}
                onClick={(data, index) => handleItemClick(index, onItemClick, chartData)}
                cursor={onItemClick ? 'pointer' : 'auto'}
              />
              <Bar
                dataKey='value'
                fill='black'
                label={BarLabel(color)}
                isAnimationActive={false}
                minPointSize={10}
                onClick={(data, index) => handleItemClick(index, onItemClick, chartData)}
                cursor={onItemClick ? 'pointer' : 'auto'}
              >
                {cells}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </this.chartWrapper>
      </Segment.Child>,
    ]
  }

}


export default TemperatureBar



// WEBPACK FOOTER //
// ./src/components/UI/Chart/TemperatureBar.jsx